// lib/z-index.js — Zentrale Z-Index-Hierarchie für Boothly
// Einzige Source of Truth — überall via import { Z } from '../lib/z-index.js' nutzen.

export const Z = {
  // Base content
  base:             1,

  // Sticky UI Chrome
  bottomNav:        100,
  header:           100,

  // Floating action elements
  fab:              500,

  // First-level overlays (Sheets, Drawers)
  sheetBackdrop:    2000,
  sheet:            2001,

  // Second-level overlays (Sheet-in-Sheet, Sub-Modal)
  nestedBackdrop:   2100,
  nestedSheet:      2101,

  // Popovers, Dropdowns, Date-Picker
  popoverBackdrop:  2200,
  popover:          2201,

  // Live-Markt Vollbild-Overlay (über allen Sheets der Hub-Ebene)
  liveOverlay:      3000,

  // Demo-Modus-Kapsel + Szenario-Sheet (nur VITE_DEMO-Build), unter Toasts
  demoBadge:        8000,

  // Always-on-top
  toast:            9000,
  criticalError:    9500,
};
